import KeywordListSliderPanel from './KeywordListSliderPanel.vue';

export default KeywordListSliderPanel;
